import { render, staticRenderFns } from "./ProductDifference.vue?vue&type=template&id=6dbafbca&"
import script from "./ProductDifference.vue?vue&type=script&lang=js&"
export * from "./ProductDifference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports